import React from "react"
import { MyMazdaRegister } from "AtomicContainers"
import { MyMazdaWrapper } from "containers"

const MyMazdaRegistration = props => (
  <MyMazdaWrapper
    breadcrumb={["MyMazda", "Registration"]}
    backButton
    onLoadMessage={{
      message: props.registrationTokenExpiredText,
      type: "ERROR"
    }}>
    <MyMazdaRegister {...props} />
  </MyMazdaWrapper>
)

export default MyMazdaRegistration



// WEBPACK FOOTER //
// ./src/blocks/mymazda/registration/index.jsx